import { api } from "../api";
export async function getPromotedLibraryFlows({
  isAutomation = false,
  limit = 4,
}) {
  try {
    const result = await api.libraryFlow.findMany({
      select: {
        id: true,
        title: true,
        description: true,
        fullDescription: true,
        isAutomation: true,
        automationType: true,
        flowImageUrl: true,
        category: true,
        originalScenario: {
          id: true,
          name: true,
          campaign: {
            id: true,
            whatsappTemplate: {
              id: true,
              whatsappTemplateName: true,
              headerParameters: true,
              bodyParameters: true,
              urlClicks: true,
              redirectionUrl: {
                url: true,
              },
            },
          },
        },
        requirements: true,
        tags: true,
        thumbnailUrl: true,
        position: true,
        isPromoted: true,
        createdAt: true,
      },
      filter: {
        isActive: { notEquals: false },
        isPromoted: { equals: true },
        isAutomation: { equals: isAutomation },
      },
      sort: {
        position: "Ascending",
      },
      first: limit,
    });

    return result || [];
  } catch (error) {
    console.error("Erreur lors de la récupération des flows promus:", error);
    return [];
  }
}
